import { render } from "./ArgentinaPage.vue?vue&type=template&id=873b751e&scoped=true"
import script from "./ArgentinaPage.vue?vue&type=script&lang=js"
export * from "./ArgentinaPage.vue?vue&type=script&lang=js"

import "./ArgentinaPage.vue?vue&type=style&index=0&id=873b751e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-873b751e"]])

export default __exports__